import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '../components/Navbar';
import LinkSelectorModal from '../components/LinkSelectorModal';
import './Financeiro.css';

const Financeiro = () => {
    const [transactions, setTransactions] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState('');
    const [statusFilter, setStatusFilter] = useState(''); // '' = All, 'Pendente', 'Concluído'
    const [usePeriod, setUsePeriod] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editingTransaction, setEditingTransaction] = useState(null);
    const [showLinkModal, setShowLinkModal] = useState(false);
    const [linkedEntity, setLinkedEntity] = useState(null); // { type, data }
    const [searchType, setSearchType] = useState('description');
    const [searchValue, setSearchValue] = useState('');
    const [calendarMenuData, setCalendarMenuData] = useState(null); // { id, rect }
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({
        Tipo: 'Pagar',
        Descricao: '',
        Entidade: '',
        Valor: '',
        DataVencimento: '',
        MetodoPagamento: 'Pix',
        ChavePagamento: '',
        Observacao: '',
        TotalParcelas: 1,
        updateGroup: false,
        IDPedido: null,
        IDFuncionario: null,
        IDFornecedor: null,
        SequenciaPedido: ''
    });

    const months = [
        { val: '', label: 'Ano Inteiro' },
        { val: '1', label: 'Janeiro' },
        { val: '2', label: 'Fevereiro' },
        { val: '3', label: 'Março' },
        { val: '4', label: 'Abril' },
        { val: '5', label: 'Maio' },
        { val: '6', label: 'Junho' },
        { val: '7', label: 'Julho' },
        { val: '8', label: 'Agosto' },
        { val: '9', label: 'Setembro' },
        { val: '10', label: 'Outubro' },
        { val: '11', label: 'Novembro' },
        { val: '12', label: 'Dezembro' }
    ];

    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear + 10; i++) {
        years.push(i);
    }

    // Helper: Converte de DD/MM/AAAA para YYYY-MM-DD (ISO)
    const brToISO = (brDate) => {
        if (!brDate) return '';
        const parts = brDate.split('/');
        if (parts.length !== 3) return '';
        const [day, month, year] = parts;
        if (!day || !month || !year) return '';
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    // Helper: Converte de YYYY-MM-DD (ISO) para DD/MM/AAAA
    const isoToBR = (isoDate) => {
        if (!isoDate) return '';
        const simpleDate = isoDate.split('T')[0];
        const parts = simpleDate.split('-');
        if (parts.length !== 3) return '';
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;
    };

    const fetchTransactions = useCallback(async () => {
        setLoading(true);
        try {
            let url = `/api/financas?status=${statusFilter}`;
            if (usePeriod) {
                if (startDate) url += `&startDate=${brToISO(startDate)}`;
                if (endDate) url += `&endDate=${brToISO(endDate)}`;
            } else {
                url += `&year=${year}&month=${month}`;
            }

            if (searchValue) {
                url += `&searchType=${searchType}&searchValue=${encodeURIComponent(searchValue)}`;
            }
            const res = await fetch(url, { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setTransactions(data);
            }
        } catch (error) {
            console.error('Erro ao buscar finanças:', error);
        } finally {
            setLoading(false);
        }
    }, [year, month, statusFilter, usePeriod, startDate, endDate, searchType, searchValue]);

    useEffect(() => {
        const fetchUser = async () => {
            const res = await fetch('/api/auth/me', { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setUser(data.user);
            }
        };
        fetchUser();
    }, []);

    useEffect(() => {
        fetchTransactions();
    }, [fetchTransactions]);

    useEffect(() => {
        const handleBeforePrint = () => {
            document.body.classList.add('printing-finance');
        };
        const handleAfterPrint = () => {
            document.body.classList.remove('printing-finance');
        };

        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);

        return () => {
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
            document.body.classList.remove('printing-finance');
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            const url = editingTransaction ? `/api/financas/${editingTransaction.ID}` : '/api/financas';
            const method = editingTransaction ? 'PUT' : 'POST';

            const dataToSend = {
                ...formData,
                DataVencimento: brToISO(formData.DataVencimento)
            };

            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dataToSend),
                credentials: 'include'
            });
            if (res.ok) {
                alert(editingTransaction ? 'Lançamento atualizado!' : 'Lançamento cadastrado!');
                setShowModal(false);
                setEditingTransaction(null);
                fetchTransactions();
                setFormData({
                    Tipo: 'Pagar',
                    Descricao: '',
                    Entidade: '',
                    Valor: '',
                    DataVencimento: '',
                    MetodoPagamento: 'Pix',
                    ChavePagamento: '',
                    Observacao: '',
                    TotalParcelas: 1,
                    updateGroup: false,
                    IDPedido: null,
                    IDFuncionario: null,
                    IDFornecedor: null,
                    SequenciaPedido: ''
                });
                setLinkedEntity(null);
            }
        } catch (error) {
            console.error('Erro ao salvar lançamento:', error);
        }
    };

    const formatDate = (dateVal) => {
        if (!dateVal) return '';
        if (typeof dateVal === 'string' && dateVal.includes('/')) return dateVal;
        if (typeof dateVal === 'string' && dateVal.includes('-')) return isoToBR(dateVal);
        const d = new Date(dateVal);
        const day = String(d.getUTCDate()).padStart(2, '0');
        const month = String(d.getUTCMonth() + 1).padStart(2, '0');
        const year = d.getUTCFullYear();
        return `${day}/${month}/${year}`;
    };

    const openEditModal = (t) => {
        setEditingTransaction(t);
        setFormData({
            Tipo: t.Tipo,
            Descricao: t.Descricao,
            Entidade: t.Entidade || '',
            Valor: t.Valor,
            DataVencimento: formatDate(t.DataVencimento),
            MetodoPagamento: t.MetodoPagamento,
            ChavePagamento: t.ChavePagamento || '',
            Observacao: t.Observacao || '',
            TotalParcelas: t.TotalParcelas,
            Status: t.Status,
            updateGroup: false,
            IDPedido: t.IDPedido,
            IDFuncionario: t.IDFuncionario,
            IDFornecedor: t.IDFornecedor,
            SequenciaPedido: t.SequenciaPedido || ''
        });

        if (t.IDPedido) setLinkedEntity({ type: 'pedido', data: { ID: t.IDPedido } });
        else if (t.IDFuncionario) setLinkedEntity({ type: 'funcionario', data: { ID: t.IDFuncionario, PrimeiroNome: t.Entidade.split(' ')[0] } });
        else if (t.IDFornecedor) setLinkedEntity({ type: 'fornecedor', data: { ID: t.IDFornecedor, NomeEmpresa: t.Entidade } });
        else setLinkedEntity(null);

        setShowModal(true);
    };

    const toggleStatus = async (id, currentStatus) => {
        const newStatus = currentStatus === 'Pendente' ? 'Concluído' : 'Pendente';
        try {
            await fetch(`/api/financas/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Status: newStatus }),
                credentials: 'include'
            });
            fetchTransactions();
        } catch (error) {
            console.error('Erro ao atualizar status:', error);
        }
    };

    const deleteTransaction = async (id, isGroup) => {
        let deleteGroup = false;
        if (isGroup) {
            const choice = window.confirm('Deseja excluir TODO o GRUPO de parcelas? \n\n[OK] = Excluir GRUPO INTEIRO (👥)\n[Cancelar] = Ver mais opções...');
            if (choice) {
                deleteGroup = true;
            } else {
                const choiceSingle = window.confirm('Deseja excluir APENAS ESTA parcela específica? \n\n[OK] = Excluir apenas esta\n[Cancelar] = Abortar');
                if (!choiceSingle) return;
                deleteGroup = false;
            }
        } else {
            if (!window.confirm('Deseja excluir este lançamento?')) return;
        }

        try {
            await fetch(`/api/financas/${id}${deleteGroup ? '?deleteGroup=true' : ''}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            fetchTransactions();
        } catch (error) {
            console.error('Erro ao excluir:', error);
        }
    };

    const totals = transactions.reduce((acc, t) => {
        const valor = parseFloat(t.Valor);
        if (t.Tipo === 'Pagar') acc.pagar += valor;
        else acc.receber += valor;

        if (t.Status === 'Concluído') {
            if (t.Tipo === 'Pagar') acc.pago += valor;
            else acc.recebido += valor;
        }
        return acc;
    }, { pagar: 0, receber: 0, pago: 0, recebido: 0 });

    const saldo = totals.receber - totals.pagar;

    const formatCurrency = (val) => {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(val || 0);
    };

    const handleDateInput = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length >= 2) value = value.slice(0, 2) + '/' + value.slice(2);
        if (value.length >= 5) value = value.slice(0, 5) + '/' + value.slice(5, 9);
        e.target.value = value;
        setFormData({ ...formData, [e.target.name]: value });
    };

    const handlePeriodDateInput = (e, setter) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length >= 2) value = value.slice(0, 2) + '/' + value.slice(2);
        if (value.length >= 5) value = value.slice(0, 5) + '/' + value.slice(5, 9);
        e.target.value = value;
        setter(value);
    };

    const handleHiddenDateChange = (e) => {
        const isoValue = e.target.value;
        if (isoValue) {
            const brValue = isoToBR(isoValue);
            setFormData(prev => ({ ...prev, DataVencimento: brValue }));
        }
    };

    const handleHiddenPeriodChange = (e, setter) => {
        const isoValue = e.target.value;
        if (isoValue) {
            const brValue = isoToBR(isoValue);
            setter(brValue);
        }
    };

    const downloadICS = () => {
        const pendingTransactions = transactions.filter(t => t.Status === 'Pendente');
        if (pendingTransactions.length === 0) {
            alert('Não há lançamentos pendentes para exportar.');
            return;
        }

        let icsContent = "BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//Financeiro RA//PT\n";
        pendingTransactions.forEach(t => {
            const dateStr = new Date(t.DataVencimento).toISOString().slice(0, 10).replace(/-/g, '');
            icsContent += "BEGIN:VEVENT\n";
            icsContent += `SUMMARY:[${t.Tipo.toUpperCase()}] ${t.Descricao}\n`;
            icsContent += `DTSTART;VALUE=DATE:${dateStr}\n`;
            icsContent += `DTEND;VALUE=DATE:${dateStr}\n`;
            icsContent += `DESCRIPTION:Valor: R$ ${formatCurrency(t.Valor)}\\nEntidade: ${t.Entidade || '-'}\\nObs: ${t.Observacao || '-'}\n`;
            icsContent += "END:VEVENT\n";
        });
        icsContent += "END:VCALENDAR";

        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `financas_pendentes_${year}_${month || 'ano'}.ics`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleCalendarExport = (t, service) => {
        const title = `[${t.Tipo.toUpperCase()}] ${t.Descricao}`;
        const dateObj = new Date(t.DataVencimento);
        const isoDate = dateObj.toISOString().slice(0, 10).replace(/-/g, '');
        const details = `Valor: R$ ${formatCurrency(t.Valor)}\nEntidade: ${t.Entidade || '-'}\nChave: ${t.ChavePagamento || '-'}\nObs: ${t.Observacao || '-'}`;

        let url = '';
        if (service === 'google') {
            url = `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(title)}&dates=${isoDate}/${isoDate}&details=${encodeURIComponent(details)}`;
        } else if (service === 'microsoft') {
            const msDate = dateObj.toISOString().slice(0, 10);
            url = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(title)}&startdt=${msDate}&enddt=${msDate}&body=${encodeURIComponent(details)}&allday=true`;
        }

        if (url) window.open(url, '_blank');
        setCalendarMenuData(null);
    };

    const toggleCalendarMenu = (e, t) => {
        e.stopPropagation();
        if (calendarMenuData?.id === t.ID) {
            setCalendarMenuData(null);
        } else {
            const rect = e.currentTarget.getBoundingClientRect();
            setCalendarMenuData({ id: t.ID, t, x: rect.left, y: rect.bottom });
        }
    };

    const handleLinkSelect = (type, data) => {
        const newForm = {
            ...formData,
            IDPedido: type === 'pedido' ? data.ID : null,
            IDFuncionario: type === 'funcionario' ? data.ID : null,
            IDFornecedor: type === 'fornecedor' ? data.ID : null,
        };

        if (type === 'pedido') {
            newForm.Entidade = `Orçamento #${data.ID} (${data.clientName})`;
            newForm.Descricao = formData.Descricao || `Pagamento Orçamento ${data.ID}`;
        } else if (type === 'funcionario') {
            newForm.Entidade = `${data.PrimeiroNome} ${data.Sobrenome}`;
        } else if (type === 'fornecedor') {
            newForm.Entidade = data.NomeEmpresa;
        }

        setFormData(newForm);
        setLinkedEntity({ type, data });
    };

    const handlePrintReport = () => {
        if (!transactions || transactions.length === 0) {
            alert('Não há dados para imprimir com os filtros atuais.');
            return;
        }

        const win = window.open('', '_blank');
        const now = new Date();
        const genDate = now.toLocaleDateString('pt-BR');
        const genTime = now.toLocaleTimeString('pt-BR');
        const userName = user ? (user.full_name || user.username) : 'Sistema';

        let periodDesc = usePeriod
            ? `Período: ${startDate || 'Início'} até ${endDate || 'Hoje'}`
            : (month ? `Mês: ${months.find(m => m.val === month)?.label} / ${year}` : `Ano: ${year}`);

        if (statusFilter) {
            periodDesc += ` (${statusFilter}s)`;
        }

        const printContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Relatório Financeiro - RA Multi Services</title>
                <style>
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 30px; color: #333; line-height: 1.4; }
                    .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #000080; padding-bottom: 15px; margin-bottom: 25px; }
                    .logo-area img { height: 60px; }
                    .report-meta { text-align: right; font-size: 0.85rem; color: #555; }
                    .report-meta h1 { margin: 0; color: #000080; font-size: 1.6rem; text-transform: uppercase; }
                    
                    .filter-info { background: #f0f0f5; padding: 12px 20px; border-left: 5px solid #000080; margin-bottom: 25px; display: flex; justify-content: space-between; align-items: center; }
                    .filter-info div p { margin: 2px 0; font-weight: bold; }
                    .filter-label { color: #666; font-size: 0.8rem; text-transform: uppercase; margin-right: 10px; }

                    .summary-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px; margin-bottom: 25px; }
                    .summary-card { padding: 15px; border: 1px solid #ccc; text-align: center; background: #fff; }
                    .summary-card label { display: block; font-size: 0.75rem; color: #666; font-weight: bold; margin-bottom: 5px; text-transform: uppercase; }
                    .summary-card .val { font-size: 1.3rem; font-weight: bold; }
                    .card-receber .val { color: #006400; }
                    .card-pagar .val { color: #8b0000; }
                    .card-saldo .val.pos { color: #0000cd; }
                    .card-saldo .val.neg { color: #d00; }

                    .finance-table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 0.85rem; }
                    .finance-table th { background: #000080; color: #fff; padding: 10px; text-align: left; border: 1px solid #000080; }
                    .finance-table td { padding: 8px 10px; border: 1px solid #eee; }
                    .finance-table tr:nth-child(even) { background: #f9f9f9; }
                    .row-pagar { color: #8b0000; }
                    .row-receber { color: #006400; font-weight: 500; }
                    .status-cell { font-weight: bold; font-size: 0.75rem; text-transform: uppercase; }
                    
                    .footer { margin-top: 40px; text-align: center; font-size: 0.75rem; color: #999; border-top: 1px solid #eee; padding-top: 15px; }
                    
                    @media print {
                        body { padding: 0; }
                        .no-print { display: none; }
                        .summary-card { border: 1px solid #999; }
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <div class="logo-area">
                        <img src="/logo-ra.png" alt="RA Multi Services">
                    </div>
                    <div class="report-meta">
                        <h1>Relatório Financeiro</h1>
                        <p>Emitido por: <strong>${userName}</strong></p>
                        <p>Data: ${genDate} às ${genTime}</p>
                    </div>
                </div>

                <div class="filter-info">
                    <div>
                        <span class="filter-label">Critério:</span>
                        <p>${periodDesc}</p>
                    </div>
                    ${searchValue ? `<div><span class="filter-label">Busca:</span><p>"${searchValue}"</p></div>` : ''}
                </div>

                <div class="summary-grid">
                    <div class="summary-card card-receber">
                        <label>Total a Receber</label>
                        <span class="val">R$ ${formatCurrency(totals.receber)}</span>
                        <div style="font-size: 0.8rem; border-top: 1px solid #eee; margin-top: 5px; padding-top: 5px;">
                            Concluído: R$ ${formatCurrency(totals.recebido)}
                        </div>
                    </div>
                    <div class="summary-card card-pagar">
                        <label>Total a Pagar</label>
                        <span class="val">R$ ${formatCurrency(totals.pagar)}</span>
                        <div style="font-size: 0.8rem; border-top: 1px solid #eee; margin-top: 5px; padding-top: 5px;">
                            Pago: R$ ${formatCurrency(totals.pago)}
                        </div>
                    </div>
                    <div class="summary-card card-saldo">
                        <label>Saldo do Período</label>
                        <span class="val ${saldo >= 0 ? 'pos' : 'neg'}">R$ ${formatCurrency(saldo)}</span>
                        <div style="font-size: 0.8rem; border-top: 1px solid #eee; margin-top: 5px; padding-top: 5px;">
                            &nbsp;
                        </div>
                    </div>
                </div>

                <table class="finance-table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Descrição</th>
                            <th>Empresa/Pessoa</th>
                            <th>Método</th>
                            <th>Parcela</th>
                            <th>Valor</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${transactions.map(t => `
                            <tr>
                                <td>${formatDate(t.DataVencimento)}</td>
                                <td class="row-${t.Tipo.toLowerCase()}">${t.Descricao}</td>
                                <td>${t.Entidade || '---'}</td>
                                <td>${t.MetodoPagamento}${t.ChavePagamento ? ` (${t.ChavePagamento})` : ''}</td>
                                <td>${t.TotalParcelas > 1 ? `${t.ParcelaAtual}/${t.TotalParcelas}` : '1/1'}</td>
                                <td class="row-${t.Tipo.toLowerCase()}">R$ ${formatCurrency(t.Valor)}</td>
                                <td class="status-cell">${t.Status}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="footer">
                    <p>RA Multi Services - Sistema de Gestão Interna</p>
                    <p>Este documento é para uso exclusivo da administração.</p>
                </div>

                <script>
                    window.onload = function() {
                        window.print();
                        // window.close(); // Opcional: fechar após imprimir
                    };
                </script>
            </body>
            </html>
        `;

        win.document.write(printContent);
        win.document.close();
    };

    return (
        <div className="financeiro-container">
            <Navbar user={user} />
            <h1 className="show-print">Relatório Financeiro - RA Multi Services</h1>

            <header className="financeiro-header hide-print">
                <div className="header-left">
                    <h1>Sistema Financeiro</h1>
                    <div className="header-filters">
                        {!usePeriod ? (
                            <>
                                <select value={year} onChange={(e) => setYear(e.target.value)} className="year-select">
                                    <option value="">Todos os Anos</option>
                                    {years.map(y => <option key={y} value={y}>{y}</option>)}
                                </select>
                                <select value={month} onChange={(e) => setMonth(e.target.value)} className="month-select">
                                    {months.map(m => <option key={m.val} value={m.val}>{m.label}</option>)}
                                </select>
                            </>
                        ) : (
                            <div className="period-inputs" title="Filtro por período DD/MM/AAAA">
                                <div className="date-field-hint">
                                    <label>De:</label>
                                    <div className="date-input-wrapper">
                                        <input
                                            type="text"
                                            value={startDate}
                                            onChange={(e) => handlePeriodDateInput(e, setStartDate)}
                                            placeholder="DD/MM/AAAA"
                                            maxLength="10"
                                            className="date-input-br"
                                        />
                                        <input
                                            type="date"
                                            className="hidden-date-picker"
                                            onChange={(e) => handleHiddenPeriodChange(e, setStartDate)}
                                            value={brToISO(startDate) || ''}
                                        />
                                        <button className="btn-calendar-trigger" onClick={(e) => e.currentTarget.previousSibling.showPicker?.() || e.currentTarget.previousSibling.click()}>📅</button>
                                    </div>
                                </div>
                                <span>até</span>
                                <div className="date-field-hint">
                                    <label>Até:</label>
                                    <div className="date-input-wrapper">
                                        <input
                                            type="text"
                                            value={endDate}
                                            onChange={(e) => handlePeriodDateInput(e, setEndDate)}
                                            placeholder="DD/MM/AAAA"
                                            maxLength="10"
                                            className="date-input-br"
                                        />
                                        <input
                                            type="date"
                                            className="hidden-date-picker"
                                            onChange={(e) => handleHiddenPeriodChange(e, setEndDate)}
                                            value={brToISO(endDate) || ''}
                                        />
                                        <button className="btn-calendar-trigger" onClick={(e) => e.currentTarget.previousSibling.showPicker?.() || e.currentTarget.previousSibling.click()}>📅</button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="status-select">
                            <option value="">Todos os Status</option>
                            <option value="Pendente">Pendentes</option>
                            <option value="Concluído">Concluídos</option>
                        </select>
                        <button
                            className={`btn-classic btn-toggle-period ${usePeriod ? 'active' : ''}`}
                            onClick={() => setUsePeriod(!usePeriod)}
                            title={usePeriod ? "Voltar para Filtro Mensal" : "Filtrar por Período Customizado"}
                        >
                            {usePeriod ? '📅 Ver Mensal' : '📅 Ver Período'}
                        </button>

                        <div className="search-box-finance">
                            <select value={searchType} onChange={(e) => setSearchType(e.target.value)} className="search-type-select">
                                <option value="description">Descrição</option>
                                <option value="method">Método/Chave</option>
                                <option value="entity">Empresa/Pessoa</option>
                            </select>
                            <div className="search-input-wrapper">
                                <input
                                    type="text"
                                    placeholder="Pesquisar..."
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    className="search-input"
                                />
                                {searchValue && <button className="btn-clear-search" onClick={() => setSearchValue('')}>×</button>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-right" style={{ display: 'flex', gap: '10px' }}>
                    <button className="btn-bulk-export" title="Imprimir Relatório" onClick={handlePrintReport}>
                        <span>🖨️</span> Imprimir Relatório
                    </button>
                    <button className="btn-bulk-export" title="Baixar arquivo (.ics) para importar no Calendário" onClick={downloadICS}>
                        <span>📥</span> Exportar Pendentes (.ics)
                    </button>
                    <button className="btn-add-finance" onClick={() => setShowModal(true)}>+ Novo Lançamento</button>
                </div>
            </header>

            <div className="financeiro-summary">
                <div className="summary-card card-receber">
                    <label>A Receber</label>
                    <span className="value">R$ {formatCurrency(totals.receber)}</span>
                    <span className="sub">Concluído: R$ {formatCurrency(totals.recebido)}</span>
                </div>
                <div className="summary-card card-pagar">
                    <label>A Pagar</label>
                    <span className="value">R$ {formatCurrency(totals.pagar)}</span>
                    <span className="sub">Pago: R$ {formatCurrency(totals.pago)}</span>
                </div>
                <div className="summary-card card-saldo">
                    <label>
                        {usePeriod ? (
                            `Saldo de ${startDate || '...'} até ${endDate || '...'}`
                        ) : (
                            month ? 'Saldo Mensal' : 'Saldo Anual'
                        )}
                    </label>
                    <span className={`value ${saldo >= 0 ? 'pos' : 'neg'}`}>R$ {formatCurrency(saldo)}</span>
                </div>
            </div>

            <main className="financeiro-content">
                {loading ? (
                    <div className="loading-state">
                        <img src="https://i.gifer.com/ZKZg.gif" alt="Loading" />
                        <p>Carregando finanças...</p>
                    </div>
                ) : (
                    <table className="financeiro-table">
                        <thead>
                            <tr>
                                <th className="hide-print">Status</th>
                                <th>Data</th>
                                <th>Descrição</th>
                                <th>Empresa/Pessoa</th>
                                <th>Método / Chave</th>
                                <th>Parcela</th>
                                <th>Valor</th>
                                <th className="hide-print">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactions.map(t => (
                                <tr key={t.ID} className={t.Tipo.toLowerCase()}>
                                    <td className="hide-print">
                                        <input
                                            type="checkbox"
                                            checked={t.Status === 'Concluído'}
                                            onChange={() => toggleStatus(t.ID, t.Status)}
                                        />
                                    </td>
                                    <td>{formatDate(t.DataVencimento)}</td>
                                    <td onClick={() => openEditModal(t)} style={{ cursor: 'pointer' }}>
                                        <div className="desc-info">
                                            <strong>{t.Descricao}</strong>
                                            {t.Observacao && <span className="obs-nota">{t.Observacao}</span>}
                                        </div>
                                    </td>
                                    <td>{t.Entidade}</td>
                                    <td>
                                        <div className="metodo-info">
                                            <span>{t.MetodoPagamento}</span>
                                            {t.ChavePagamento && <span className="chave-nota">{t.ChavePagamento}</span>}
                                            {t.IDPedido && <span className="link-badge">Orçamento #{t.IDPedido} {t.SequenciaPedido && `Seq:${t.SequenciaPedido}`}</span>}
                                        </div>
                                    </td>
                                    <td>{t.ParcelaAtual}/{t.TotalParcelas}</td>
                                    <td className="valor-cell">R$ {formatCurrency(t.Valor)}</td>
                                    <td className="hide-print">
                                        <button className="btn-icon" title="Agendar no Calendário" onClick={(e) => toggleCalendarMenu(e, t)}>📅</button>
                                        <button className="btn-icon" title="Editar" onClick={() => openEditModal(t)}>✏️</button>
                                        <button className="btn-icon" title="Excluir" onClick={() => deleteTransaction(t.ID, t.TotalParcelas > 1)}>🗑️</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </main>

            {
                showModal && (
                    <div className="modal-overlay">
                        <div className="modal-classic finance-modal">
                            <div className="modal-header">
                                <span>{editingTransaction ? 'Editar Lançamento' : 'Novo Lançamento Financeiro'}</span>
                                <button onClick={() => setShowModal(false)}>X</button>
                            </div>
                            <form onSubmit={handleSave} className="modal-body">
                                <div className="form-grid">
                                    <div className="field">
                                        <label>Tipo</label>
                                        <select name="Tipo" value={formData.Tipo} onChange={handleInputChange}>
                                            <option value="Pagar">A Pagar</option>
                                            <option value="Receber">A Receber</option>
                                        </select>
                                    </div>
                                    <div className="field">
                                        <label>Descrição</label>
                                        <input type="text" name="Descricao" value={formData.Descricao} onChange={handleInputChange} />
                                    </div>
                                    <div className="field">
                                        <label>Empresa/Pessoa</label>
                                        <input type="text" name="Entidade" value={formData.Entidade} onChange={handleInputChange} />
                                    </div>
                                    <div className="field">
                                        <label>Valor</label>
                                        <input type="number" step="0.01" name="Valor" value={formData.Valor} onChange={handleInputChange} />
                                    </div>
                                    <div className="field">
                                        <label>Vencimento (DD/MM/AAAA)</label>
                                        <div className="date-input-wrapper">
                                            <input
                                                type="text"
                                                name="DataVencimento"
                                                value={formData.DataVencimento}
                                                onChange={handleDateInput}
                                                placeholder="DD/MM/AAAA"
                                                maxLength="10"
                                                required
                                                className="date-input-br"
                                            />
                                            <input
                                                type="date"
                                                className="hidden-date-picker"
                                                onChange={handleHiddenDateChange}
                                                value={brToISO(formData.DataVencimento) || ''}
                                            />
                                            <button type="button" className="btn-calendar-trigger" onClick={(e) => e.currentTarget.previousSibling.showPicker?.() || e.currentTarget.previousSibling.click()}>📅</button>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label>Método de Pagamento</label>
                                        <select name="MetodoPagamento" value={formData.MetodoPagamento} onChange={handleInputChange}>
                                            <option value="Pix">Pix</option>
                                            <option value="Boleto">Boleto</option>
                                            <option value="Dinheiro">Dinheiro</option>
                                            <option value="Transferência">Transferência</option>
                                            <option value="Outro">Outro</option>
                                        </select>
                                    </div>
                                    <div className="field">
                                        <label>Chave Pix / Nº Boleto</label>
                                        <input type="text" name="ChavePagamento" value={formData.ChavePagamento} onChange={handleInputChange} placeholder="Cole aqui a chave ou nº" />
                                    </div>
                                    <div className="field">
                                        <label>Parcelas</label>
                                        <input type="number" name="TotalParcelas" value={formData.TotalParcelas} onChange={handleInputChange} min="1" disabled={!!editingTransaction} />
                                    </div>

                                    <div className="field full-width link-field-row">
                                        <label>Vínculo do Lançamento</label>
                                        <div className="link-controls">
                                            <button type="button" className="btn-classic btn-sm" onClick={() => setShowLinkModal(true)}>
                                                {linkedEntity ? 'Alterar Vínculo' : '🔗 Vincular Orçamento/Func/Forn'}
                                            </button>
                                            {linkedEntity && (
                                                <div className="linked-info-badge">
                                                    <span>✔️ {linkedEntity.type === 'pedido' ? `Orçamento #${linkedEntity.data.ID}` :
                                                        linkedEntity.type === 'funcionario' ? `Func: ${linkedEntity.data.PrimeiroNome}` :
                                                            `Forn: ${linkedEntity.data.NomeEmpresa}`}</span>
                                                    <button type="button" className="btn-remove-link" onClick={() => { setLinkedEntity(null); setFormData({ ...formData, IDPedido: null, IDFuncionario: null, IDFornecedor: null, SequenciaPedido: '' }); }}>×</button>
                                                </div>
                                            )}
                                            {linkedEntity?.type === 'pedido' && (
                                                <div className="sequence-input">
                                                    <label>Seq:</label>
                                                    <input
                                                        type="number"
                                                        name="SequenciaPedido"
                                                        value={formData.SequenciaPedido}
                                                        onChange={handleInputChange}
                                                        placeholder="Ex: 1"
                                                        style={{ width: '60px' }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {editingTransaction && formData.TotalParcelas > 1 && (
                                        <div className="field full-width checkbox-field">
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                <input
                                                    type="checkbox"
                                                    name="updateGroup"
                                                    checked={formData.updateGroup}
                                                    onChange={(e) => setFormData({ ...formData, updateGroup: e.target.checked })}
                                                />
                                                <strong>Atualizar TODAS as parcelas deste grupo (👥)</strong>
                                            </label>
                                        </div>
                                    )}
                                    <div className="field full-width">
                                        <label>Observação</label>
                                        <textarea name="Observacao" value={formData.Observacao} onChange={handleInputChange} rows="3" placeholder="Notas adicionais..."></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn-classic">Salvar</button>
                                    <button type="button" className="btn-classic" onClick={() => setShowModal(false)}>Cancelar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )
            }

            {
                calendarMenuData && (
                    <div
                        className="calendar-choice-menu"
                        style={{ top: calendarMenuData.y + 5, left: calendarMenuData.x }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="menu-header">Exportar para:</div>
                        <button onClick={() => handleCalendarExport(calendarMenuData.t, 'google')} className="menu-item">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Calendar_icon_%282020%29.svg" alt="Google" width="16" /> Google Agenda
                        </button>
                        <button onClick={() => handleCalendarExport(calendarMenuData.t, 'microsoft')} className="menu-item">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/d/df/Microsoft_Office_Outlook_%282018%E2%80%93present%29.svg" alt="Outlook" width="16" /> Microsoft / Outlook
                        </button>
                        <div className="menu-divider"></div>
                        <button onClick={() => setCalendarMenuData(null)} className="menu-item cancel">Cancelar</button>
                    </div>
                )
            }

            {
                showLinkModal && (
                    <LinkSelectorModal
                        onClose={() => setShowLinkModal(false)}
                        onSelect={handleLinkSelect}
                    />
                )
            }
        </div >
    );
};

export default Financeiro;
